export default {
    integrations_tab_id: 'Id',
    integrations_tab_integration: 'Integración',
    integrations_tab_parameters: 'Parametros',
    integrations_tab_status: 'Estado',
    integrations_tab_companies: 'Compañias',
    integrations_tab_accounts: 'Cuentas',
    integrations_tab_advanced_filters: 'Filtros avanzados',
    integrations_tab_apply: 'Aplicar',
    integrations_tab_tags: 'Etiquetas',
    integrations_tab_active_integrations_only: 'Sólo cuentas activas',
    integrations_tab_yes: 'Si',
    integrations_tab_no: 'No',
    integrations_tab_authenticate_cloud: 'Iniciar sesión como cliente',
    integrations_tab_re_sync_backend_information: 'Re-sincronización de la información del backend',
    integrations_tab_devices: 'Dispositivos',
    integrations_tab_package: 'Paquete',
    integrations_tab_crm: 'Id. de Salesforce',
    integrations_tab_add_account: 'Agregar cuenta',
    integrations_tab_edit: 'Editar',
    integrations_tab_remove_filters: 'Eliminar los filtros',
    integrations_tab_account_details: 'Detalles de la cuenta',
    integrations_tab_import_from_p4: 'Importar desde P4',
    integrations_tab_reprocess_odo_hours: 'Reprocesar Odo/Hrs',
    integrations_tab_new_status: 'Nuevo Estado',
    integrations_tab_at: 'el',
    integrations_tab_next_scheduled_action: 'Próxima acción programada',
    integrations_tab_on: 'en',
    integrations_tab_add_integration:'Adicionar integración',
    integrations_tab_external_id: "Id Externo",
    integrations_tab_title: "Integraciones",
    integrations_tab_cerebrumx_permission_error: "No tiene permisos para borrar integraciones de CerebrumX"

};